import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
  Provider,
} from '@angular/core';
import { KeycloakClient } from '@core/services/keycloak/keycloak.client';
import { ServerEventService } from './server-event.service';
import { SSE_EVENT_HANDLER, SSE_HANDLER_CONFIG } from './sse-event-handler';
import {
  SSE_RECONNECT_HANDLER,
  SSE_RECONNECT_HANDLERS,
} from './sse-reconnect-handler';

// generates providers for all handlers defined in SSE_HANDLER_CONFIG
const provideSseHandlers = (): Provider[] => {
  return Object.values(SSE_HANDLER_CONFIG).map((handler) => ({
    provide: SSE_EVENT_HANDLER,
    useClass: handler,
    multi: true,
  }));
};

// generates providers for all reconnect handlers
const provideSseReconnectHandlers = (): Provider[] => {
  return SSE_RECONNECT_HANDLERS.map((handler) => ({
    provide: SSE_RECONNECT_HANDLER,
    useClass: handler,
    multi: true,
  }));
};

// hooks sse connection into keycloak auth lifecycle
const provideSseAuthHook = (): EnvironmentProviders => {
  return provideAppInitializer(() => {
    const keycloakClient = inject(KeycloakClient);
    const serverEvents = inject(ServerEventService);
    const keycloak = keycloakClient.getKeycloakInstance();

    keycloak.onAuthSuccess = () => serverEvents.connect();
    keycloak.onAuthLogout = () => serverEvents.disconnect();

    // connect immediately if session already exists (check-sso)
    if (keycloakClient.isAuthenticated()) {
      serverEvents.connect();
    }
  });
};

export const provideSse = (): (Provider | EnvironmentProviders)[] => {
  return [
    ...provideSseHandlers(),
    ...provideSseReconnectHandlers(),
    provideSseAuthHook(),
  ];
};
